import React from 'react';
interface PanelProps {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  bodyClassName?: string;
}
export function Panel({
  title,
  subtitle,
  actions,
  children,
  className = '',
  bodyClassName = 'p-5'
}: PanelProps) {
  return <section className={`rounded-lg border border-border bg-white shadow-[0_1px_2px_rgba(0,59,113,0.05)] ${className}`} data-id="element-587" data-mp="35ds7rza1ta0b">
      {(title || actions) && <header className="flex flex-wrap items-center justify-between gap-3 border-b border-border px-5 py-3.5" data-id="element-588" data-mp="3f4mxxeqf0tr1">
          <div data-id="element-589" data-mp="3t45vjdllomp3">
            {title && <h2 className="text-[15px] font-semibold text-[#003B71]" data-id="element-590" data-mp="3t3cu8s5eupec">{title}</h2>}
            {subtitle && <p className="text-xs text-muted-foreground" data-id="element-591" data-mp="3o6cn0dwtrgln">{subtitle}</p>}
          </div>
          {actions && <div className="flex flex-wrap items-center gap-2" data-id="element-592" data-mp="1yrfy4lw0wvcy">{actions}</div>}
        </header>}
      <div className={bodyClassName} data-id="element-593" data-mp="1tsbo5t19ytlk">{children}</div>
    </section>;
}